import { FaWhatsapp } from 'react-icons/fa';
import { useWhatsApp } from '../../context/WhatsAppContext';

export default function WhatsAppFloat() {
  const { openWhatsAppModal } = useWhatsApp();

  return (
    <button
      onClick={openWhatsAppModal}
      aria-label="Contato via WhatsApp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-green-600 text-white flex items-center justify-center shadow-lg shadow-green-500/30 hover:shadow-green-500/50 hover:scale-105 transition-all float-bounce"
    >
      <FaWhatsapp className="w-6 h-6" />
    </button>
  );
}